/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { get } from "@ember/object";
import ScaleSurveyEditionFormComponent from "parog-web/components/abstract/scale-survey-edition-form";
import type { Payload } from "parog-web/components/forc/abstract/journal-event-based-component";
import PhqNineDeclaredJournalEvent from "parog-web/models/phq-nine-declared-journal-event";
import phqNineScoreDescription from "parog-web/utils/phq-nine-score-description";

export default class PhqNineEditionFormComponent extends ScaleSurveyEditionFormComponent {
  static forcDisplayName =
    "Questionnaire d'évaluation de la dépression - PHQ-9";
  static fullComponentId = "scale-surveys/phq-nine-edition-form";
  static journalEventClass = PhqNineDeclaredJournalEvent;

  get numberOfItems(): ScaleSurveyEditionFormComponent["numberOfItems"] {
    return 9;
  }

  get maximalScore(): ScaleSurveyEditionFormComponent["maximalScore"] {
    return 27;
  }

  _computeScore(payload: Payload): ScaleSurveyEditionFormComponent["score"] {
    const number = this.questionIds.reduce(
      (total, index) => total + parseInt(get(payload, index) as string),
      0
    );

    return {
      number,
      description: phqNineScoreDescription(number)
    };
  }
}
